'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { type AssetDragItem, hasAssetPayload, parsePayload } from './asset-dnd';
interface UseAssetDropParams {
  onDrop: (items: AssetDragItem[], event: React.DragEvent) => void;
  canDrop?: (items: AssetDragItem[]) => boolean;
  disabled?: boolean;
}
export function useAssetDrop(t0) {
  const $ = _c(23);
  const {
    onDrop,
    canDrop,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const [isDragOver, setIsDragOver] = useState(false);
  const [isInvalidDragOver, setIsInvalidDragOver] = useState(false);
  const enterCountRef = useRef(0);
  let t2;
  if ($[0] !== disabled) {
    t2 = e => {
      if (disabled) {
        return;
      }
      e.preventDefault();
      enterCountRef.current = enterCountRef.current + 1;
      if (enterCountRef.current !== 1) {
        return;
      }
      if (hasAssetPayload(e.dataTransfer.types)) {
        setIsDragOver(true);
      } else {
        setIsInvalidDragOver(true);
      }
    };
    $[0] = disabled;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleDragEnter = t2;
  let t3;
  if ($[2] !== disabled) {
    t3 = e_0 => {
      if (disabled) {
        return;
      }
      e_0.preventDefault();
      enterCountRef.current = enterCountRef.current - 1;
      if (enterCountRef.current <= 0) {
        enterCountRef.current = 0;
        setIsDragOver(false);
        setIsInvalidDragOver(false);
      }
    };
    $[2] = disabled;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleDragLeave = t3;
  let t4;
  if ($[4] !== disabled) {
    t4 = e_1 => {
      if (disabled) {
        return;
      }
      e_1.preventDefault();
      if (hasAssetPayload(e_1.dataTransfer.types)) {
        e_1.dataTransfer.dropEffect = "copy";
      } else {
        e_1.dataTransfer.dropEffect = "none";
      }
    };
    $[4] = disabled;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleDragOver = t4;
  let t5;
  if ($[6] !== canDrop || $[7] !== disabled || $[8] !== onDrop) {
    t5 = e_2 => {
      e_2.preventDefault();
      enterCountRef.current = 0;
      setIsDragOver(false);
      setIsInvalidDragOver(false);
      if (disabled) {
        return;
      }
      const items = parsePayload(e_2.dataTransfer);
      if (!items || items.length === 0) {
        return;
      }
      if (canDrop && !canDrop(items)) {
        return;
      }
      onDrop(items, e_2);
    };
    $[6] = canDrop;
    $[7] = disabled;
    $[8] = onDrop;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleDrop = t5;
  let t6;
  let t7;
  if ($[10] !== isDragOver || $[11] !== isInvalidDragOver) {
    t6 = () => {
      const isActive = isDragOver || isInvalidDragOver;
      if (!isActive) {
        return;
      }
      const reset = () => {
        enterCountRef.current = 0;
        setIsDragOver(false);
        setIsInvalidDragOver(false);
      };
      window.addEventListener("dragend", reset);
      window.addEventListener("drop", reset);
      window.addEventListener("blur", reset);
      return () => {
        window.removeEventListener("dragend", reset);
        window.removeEventListener("drop", reset);
        window.removeEventListener("blur", reset);
      };
    };
    t7 = [isDragOver, isInvalidDragOver];
    $[10] = isDragOver;
    $[11] = isInvalidDragOver;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] !== handleDragEnter || $[15] !== handleDragLeave || $[16] !== handleDragOver || $[17] !== handleDrop) {
    t8 = {
      onDrop: handleDrop,
      onDragOver: handleDragOver,
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave
    };
    $[14] = handleDragEnter;
    $[15] = handleDragLeave;
    $[16] = handleDragOver;
    $[17] = handleDrop;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const dropProps = t8;
  const t9 = !disabled && isDragOver;
  const t10 = !disabled && isInvalidDragOver;
  let t11;
  if ($[19] !== dropProps || $[20] !== t10 || $[21] !== t9) {
    t11 = {
      dropProps,
      isDragOver: t9,
      isInvalidDragOver: t10
    };
    $[19] = dropProps;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}